import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  Spinner,
  Table,
} from 'react-bootstrap';
import { updateSelectedElementAction } from '../../../actions/instances/elements';
import CreateSelectModal from '../../Modals/CreateSelectModal/CreateSelectModal';
import CreateElementModal from '../../Modals/Content/Elements/CreateElementModal/CreateElementModal';
import SelectElementModal from '../../Modals/Content/Elements/SelectElementModal/SelectElementModal';
import './ElementsList.scss';

const ElementsList = ({
  elements,
  onItemAdded,
  isLoading,
  cityId,
  dynastyId,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [elementsInlineEditingShown, setElementsInlineEditingShown] = useState(false);
  const navigateToComponent = (component) => {
    dispatch(updateSelectedElementAction(component));
    history.push('/instances/building-elements/view');
  };
  const itemSelected = (component) => {
    if (onItemAdded) {
      onItemAdded(component);
    }
    setElementsInlineEditingShown(false);
  };
  return (
    <div className="row mt-5">
      <div className="col-md-12 d-flex justify-content-between">
        <h6 className="ps-0">Elements</h6>
        <p>
          <CreateSelectModal
            title="Create or select an element"
            createView={(
              <CreateElementModal
                onItemCreated={comp => itemSelected(comp)}
                cityId={cityId}
                dynastyId={dynastyId}
              />
            )}
            selectView={<SelectElementModal onItemSelected={comp => itemSelected(comp)} />}
            onRequestClose={() => setElementsInlineEditingShown(false)}
            isShown={elementsInlineEditingShown}
          />
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <a href="#" onClick={() => setElementsInlineEditingShown(true)}>
            Link to Element
          </a>
        </p>
      </div>
      <div className="col-md-12">
        <Table striped bordered hover>
          <colgroup>
            <col width="10%" />
            <col width="70%" />
            <col width="20%" />
          </colgroup>
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th>Dynasty</th>
            </tr>
          </thead>
          <tbody>
            {!isLoading && elements && elements.map(element => (
              <tr>
                <td>
                  {element.images.length > 0 ? (
                    <img alt={element.name} src={element.images[0].url} height={50} width={50} style={{ objectFit: 'cover' }} />
                  ) : (
                    <img alt={element.name} src="/images/default.jpg" height={50} width={50} style={{ objectFit: 'cover' }} />
                  )}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td onClick={() => navigateToComponent(element)}>
                  {`${element.name} [${element.code}]`}
                </td>
                {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
                <td onClick={() => history.push('/dynasties')}>
                  {`${element.dynasty.name} [${element.dynasty.code}]`}
                </td>
              </tr>
            ))}
            {!isLoading && (elements === undefined || elements.length === 0) && (
              <tr className="text-center">
                <td colSpan={3}>No Components were added to this building</td>
              </tr>
            )}
            {isLoading && (
              <tr>
                <td colSpan={3} className="text-center">
                  <Spinner />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

ElementsList.propTypes = {
  elements: PropTypes.array.isRequired,
  onItemAdded: PropTypes.func,
  isLoading: PropTypes.bool,
  cityId: PropTypes.number,
  dynastyId: PropTypes.number,
};

ElementsList.defaultProps = {
  onItemAdded: undefined,
  isLoading: false,
  cityId: undefined,
  dynastyId: undefined,
};

export default ElementsList;
